<script>
	import { cssToHead, jsToHead } from './../../share/utils';
	import { onMount } from 'svelte';

	export let html;
	export let pdfName;
	export let width = 400;
	export let height = 600; // use the pfd Page-Size (e.g. 140mm x 297mm) as factor
							 // calculate like: 297/140*400 -> 849
							 // no worries, it will scale with the view, so aspect-ratio will be kept
	let div;
	
	let currentPage = 1;
	let pdfDoc = null;
	let totalPages = null;
	let pageFlip = null;

	onMount(async () => {
		// load scripts:
		jsToHead('/utils/page-flip.browser.min.js', async () => {
			cssToHead('/utils/stPageFlip.min.css');
		});
		jsToHead('/utils/pdf.js', async () => {
			const pdfjs = window['pdfjs-dist/build/pdf'];
			// The workerSrc property shall be specified.
			pdfjs.GlobalWorkerOptions.workerSrc = '/utils/pdf.worker.js';

			if(!pdfName) {
				const tempDiv = document.createElement('div');
				tempDiv.innerHTML = html;
				pdfName = tempDiv.querySelector('div').dataset.pdfSource;
			}

			const pdfData = await fetch('/pdf/' + pdfName)
				.then((res) => {
					return res.arrayBuffer();
				});

			pdfDoc = await pdfjs.getDocument({data: pdfData}).promise;
			totalPages = pdfDoc.numPages;

			for (let i = 1; i <= totalPages; i++) {
				await renderPage(i);
			}

			const flipbook = div?.querySelector('.flipbook');

			if(!flipbook) {
				return;
			}

			pageFlip = new St.PageFlip(flipbook, {
				width, // required parameter - base page width
				height, // required parameter - base page height
				maxShadowOpacity: .5,
				size: 'stretch',
				useMouseEvents: false // only our own arrows will work
			});

			pageFlip.loadFromHTML(flipbook.querySelectorAll('canvas'));

			pageFlip.on('flip', (e) => {
				currentPage = e.data; // current page number
			});
		});
	});
	
	async function renderPage(pageNumber) {
		try {
			const page = await pdfDoc.getPage(pageNumber);
			const canvas = div?.querySelector(`#pdf-canvas_${pageNumber}`);
			if(!canvas) {
				return;
			}
			const ctx = canvas.getContext('2d');
			const viewport = page.getViewport({scale: 1});
			canvas.width = viewport.width;
			canvas.height = viewport.height;
			const renderContext = {canvasContext: ctx, viewport};
			await page.render(renderContext);
			return;
		} catch (e) {
			console.log(e, pageNumber);
		}
	}
</script>
<div bind:this={div} class="pdfwalker marginbox">
	<slot/>
	<div class="clickbox prev" on:click={() => pageFlip.flipPrev()}>
		<div class="custom-arrow custom-arrow-prev">
			<i/>
		</div>
	</div>
	<div class="flipbook">
		<!-- generates Divs for all PDF-Pages, necessary for pageFlip: -->
		{#each Array(totalPages) as _, index (index)}
			<canvas id="pdf-canvas_{index + 1}"></canvas>
		{/each}
	</div>
	<div class="clickbox next" on:click={() => pageFlip.flipNext()}>
		<div class="custom-arrow custom-arrow-next">
			<i/>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";

	.pdfwalker {
		width: 100%;
		padding: px-to-em(30);
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: $color-burgeins-2;
		position: relative;

		@include for-tablet-landscape-up {
			padding: px-to-rem(142);
		}
	}
	
	.flipbook {
		width: 100%;
		max-width: 800px;
	}


	.clickbox {
		height: 100%;
		width: 25vw;
		position: absolute;
		cursor: pointer;
		z-index: 1;

		&.prev {
			left: 0;
		}

		&.next {
			right: 0;
		}
	}

	.custom-arrow {
		width: px-to-em(30);
		opacity: 0.3;
		position: absolute;
		top: 0;
		bottom: 0;
		z-index: 1;
		transition: opacity 150ms ease;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;

		@include for-tablet-landscape-up {
			width: px-to-rem(142);
		}

		> i {
			border: solid #dedede;
			border-width: 0 3px 3px 0;
			padding: 5px;
			position: relative;

			@include for-tablet-landscape-up {
				border-width: 0 5px 5px 0;
				padding: 10px;
			}
		}
	}

	.custom-arrow-prev {
		left: 0;

		> i {
			transform: rotate(135deg);
			right: -4px;
		}
	}

	.custom-arrow-next {
		right: 0;

		> i {
			transform: rotate(-45deg);
			left: -4px;
		}
	}
</style>
